import { useTranslation } from 'react-i18next';
import { createBrowserRouter, Navigate, useParams } from 'react-router-dom';

import { MultiLanguageUrl } from '@/constants/multiLanguage.constant';

import ErrorPage from '../pages/site/ErrorPage';
import AuthRouter from './auth.router';
import DashboardRouter from './dashboard.router';
import PartnerAuthRouter from './partnerAuth.router';

const ChatRedirect = () => {
  const { i18n } = useTranslation();
  const { code } = useParams();
  const encodeURICode = encodeURIComponent(code as string);
  return <Navigate to={`/${MultiLanguageUrl[i18n.language] || 'en-US'}/chat/${encodeURICode}`} replace />;
};

const router = createBrowserRouter([
  {
    path: '',
    element: <Navigate to={'/en-US/login'} />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/',
    element: <Navigate to={'/en-US/login'} />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/en-US',
    element: <Navigate to={'/en-US/login'} />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/fr-FR',
    element: <Navigate to={'/fr-FR/login'} />,
    errorElement: <ErrorPage />,
  },
  ...AuthRouter,
  ...PartnerAuthRouter,
  ...DashboardRouter,
]);

export default router;
